import { useSyncExternalStore } from 'react';
import { subscribeCurrency, getCurrencySnapshot } from '../utils/currency';

// Re-renders the calling component when the display currency or rate changes.
// Returns a key ("USD:1") that is convenient as an effect dependency.
export const useCurrency = () => useSyncExternalStore(subscribeCurrency, getCurrencySnapshot);
